<template>
  <div class="breadcrumbs-wrapper">
    <HgBreadcrumb :links="breadcrumbs" :theme="platform" />
  </div>
</template>

<script setup lang="ts">
import { HgBreadcrumb, SupportedPlatforms } from '@smg-real-estate/domus';
import type { GeoLocation } from '@smg-real-estate/geo-libs';
import { computed, toRef } from 'vue';

import { useDirectoryBreadcrumbs } from '@/composables/useDirectoryBreadcrumbs';
import { isPlatformIs24 as checkIsPlatformIs24 } from '@/helpers/Platform/platform';
import type { DirectoryType } from '@/types/directoryType';

const props = defineProps<{
  directoryType: DirectoryType;
  searchedLocations: GeoLocation[];
}>();

const isPlatformIs24 = computed(() => checkIsPlatformIs24());

const platform = computed<SupportedPlatforms>(() =>
  isPlatformIs24.value ? SupportedPlatforms.is24 : SupportedPlatforms.hg,
);

const breadcrumbs = useDirectoryBreadcrumbs(
  toRef(props, 'directoryType'),
  toRef(props, 'searchedLocations'),
);
</script>

<style lang="scss" scoped>
.breadcrumbs-wrapper > :deep([class*='HgBreadcrumb_breadcrumb'] ol) {
  li:last-child {
    pointer-events: none;
  }
}
</style>
